<template>

<div>
  <LDBsTable
    url="frota/drivers"
    defaultSort="id"
    defaultOrder="desc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-12">
      <label for="client">{{ $t('client') }}</label>
      <Combobox
        class="bg-white"
        name='client'
        :placeholder="$t('select_a_item')"
        :options="arenaClients"
        :initial-value="query.CLI_ID"
        label="CLI_DSC"
        v-model="query.CLI_ID"
        :reduce="client => client.CLI_ID"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="name">{{ $t('name') }}</label>
      <input
        type="text"
        id="name"
        name="name"
        class="form-control"
        :placeholder="$t('type_name')"
        v-model="query.nome_motorista"
      >
    </div>

    <div class="form-group col-lg-6">
      <label for="cpf">{{ $t('cpf') }}</label>
      <input
        type="text"
        class="form-control"
        id="cpf"
        name='cpf'
        :placeholder="$t('ph_cpf')"
        v-model="query.matricula_motorista"
      />
    </div>
  </LDBsTable>

  <!-- MODAL INACTIVE DRIVER -->
  <div
    class="modal fade"
    id="modalInactiveDriver"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalInactiveDriverLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalInactiveDriverLabel">
            Desativar motorista
          </h5>

          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <ul>
            <li>
              NOME: <strong>{{ dataToUpdate.nome_motorista }}</strong>
            </li>
            <li>
              CPF: <strong>{{ dataToUpdate.matricula_motorista }}</strong>
            </li>
          </ul>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            :disabled="isLoading"
          >
            {{ $t("close") }}
          </button>

          <LoaderButton
            class="mt-3"
            @click="inactiveDriver"
            :loading="isLoading"
          >
            {{ $t("to_desactive") }}
          </LoaderButton>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import { mapState } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'

export default {
  name: 'FrotaDriversList',

  components: {
    LDBsTable,
    LoaderButton,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('name'),
          field: 'nome_motorista',
          sortable: true
        },
        {
          title: this.$t('cpf'),
          field: 'matricula_motorista',
          sortable: false
        },
        {
          title: this.$t('client'),
          field: 'clientName',
          sortable: false
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value, row) {
            return `
              <button
                title="Desativar motorista"
                data-target="#modalInactiveDriver"
                data-id='${value}'
                data-nome='${row.nome_motorista}'
                data-matricula='${row.matricula_motorista}'
                data-toggle="modal"
                class="edit mb-1 btn btn-action btn-danger btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-times" />
              </button>
            `
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'frota_motoristas' }
      },
      queryToUse: {},
      query: {
        CLI_ID: undefined,
        nome_motorista: '',
        matricula_motorista: '',
      },
      dataToUpdate: {}
    }
  },

  computed: {
    ...mapState({
      lastquery: state => state.filtershistory.query,
      isLoading: state => state.frota.isLoading,
      arenaClients: state => state.arena.clients
    })
  },

  methods: {
    clear() {
      this.query.CLI_ID = undefined
      this.query.nome_motorista = ''
      this.query.matricula_motorista = ''
    },

    async inactiveDriver() {
      await this.$store.dispatch(
        'frota/inactiveDriver',
        { id: this.dataToUpdate.id }
      )

      $("#modalInactiveDriver").modal("hide");
      $("#search").trigger("click");
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['frotadrivers'] ? this.lastquery['frotadrivers'] : this.query
  },

  async mounted () {
    await this.$store.dispatch('arena/fetchClients')

    if (this.lastquery['frotadrivers']) {
      for (const [key, value] of Object.entries(this.lastquery['frotadrivers'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query

    const global = this

    $("#modalInactiveDriver").on("show.bs.modal", function (event) {
      global.errors.clear()

      const button = $(event.relatedTarget);

      global.dataToUpdate = {
        id: button.data("id"),
        nome_motorista: button.data("nome"),
        matricula_motorista: button.data("matricula"),
      }
    });

    $("#modalInactiveDriver").on("hide.bs.modal", function (event) {
      global.dataToUpdate = {}
    });
  },

  destroyed () {
    this.$store.dispatch(
      'filtershistory/setQuery',
      {
        key: 'frotadrivers',
        query: this.query
      }
    )
  },
}

</script>
